import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  Breadcrumb,
  Button,
  Col,
  Divider,
  Form,
  Layout,
  Row,
  Space,
  message,
  Table,
} from "antd";

import {
  smallTailFormItemLayout,
  smallFormItemLayout,
  tailFormItemLayout,
} from "./../../utils/Layouts";

import { useSelector } from "react-redux";

import axios from "axios";
import moment from "moment";
import ReactToPrint from "react-to-print";
import ReportFooter from "../../utils/ReportFooter";
import ReportHeading from "../../utils/ReportHeading";
import {
  authenticateAdmin,
  authenticateOwner,
} from "../../utils/authentications";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import { project_status_options } from "../../utils/Options";
import numberFormat from "../../utils/numberFormat";

const { Content } = Layout;

const url = "/api/projects/";
const title = "Project Report";

const initialValues = {
  project_status: "",
  due_date: moment().startOf("month"),
};
export default function ProjectReport({ other_set = false, history }) {
  const [records, setRecords] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [state, setState] = useState(initialValues);
  const [is_loading, setIsLoading] = useState(false);
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
    purchase_orders: [],
    warehouses: [],
  });
  const report = useRef(null);

  useEffect(() => {
    let authenticate = other_set ? authenticateOwner : authenticateAdmin;

    authenticate({
      role: auth.user?.role,
      history,
    });
  }, [auth.user]);

  const getReport = useCallback(
    ({ ...form_data }) => {
      setIsLoading(true);
      axios
        .post(`${url}history`, form_data)
        .then((response) => {
          setIsLoading(false);
          if (response.data) {
            setRecords(response.data);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          message.error("There was an error processing your request");
        });

      return () => {};
    },
    [setIsLoading, url, setRecords]
  );

  return (
    <Content style={{ padding: "0 50px" }}>
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Reports</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
        <span className="module-title">{title}</span>
        <Divider />
        <Row>
          <Col span={12}>
            <DatePickerFieldGroup
              label="Due Date"
              name="due_date"
              value={state.due_date}
              onChange={(value) => {
                setState((prevState) => ({
                  ...prevState,
                  due_date: value,
                }));
              }}
              formItemLayout={smallFormItemLayout}
            />
          </Col>
          <Col span={8}>
            <SimpleSelectFieldGroup
              label="Project Status"
              name="project_status"
              value={state.project_status}
              onChange={(value) => {
                setState((prevState) => ({
                  ...prevState,
                  project_status: value,
                }));
              }}
              formItemLayout={smallFormItemLayout}
              options={project_status_options}
            />
          </Col>
        </Row>
        <Form.Item {...tailFormItemLayout}>
          <Space>
            <Button
              loading={is_loading}
              onClick={() => {
                getReport({ ...state });
              }}
            >
              Search
            </Button>
            <ReactToPrint
              trigger={() => <Button type="primary">Print</Button>}
              bodyClass="print"
              content={() => report.current}
            />
          </Space>
        </Form.Item>
        <div ref={report}>
          <div className="report-heading">
            <ReportHeading />
            <span className="has-text-weight-bold">{title}</span>
            <br />
            {state.period_covered?.[0] &&
              state.period_covered?.[1] &&
              `${moment(state.period_covered?.[0]).format("ll")} - ${moment(
                state.period_covered?.[1]
              ).format("ll")} `}{" "}
            <br />
            Printed By : {auth.user.name} <br />
            Date/Time Printed : {moment().format("LLL")}
          </div>

          <table className="full-width sales-report-table m-t-1">
            <thead>
              <tr>
                <td>DATE AWARDED</td>
                <td>DATE COMPLETED</td>
                <th>PROJECT NAME</th>
                <th>PROJECT TYPE</th>
                <th>PROJECT PRICE</th>
                <th>ESTIMATED DAYS</th>
                <th>ACTUAL DAYS</th>
              </tr>
            </thead>
            <tbody>
              {records.map((record) => {
                return (
                  <tr>
                    <td>{moment(record.date_awarded).format("MM/DD/YY")}</td>
                    <td>
                      {record.date_of_completion
                        ? moment(record.date_completed).format("MM/DD/YY")
                        : "Not Yet Completed"}
                    </td>
                    <td>{record.name}</td>
                    <td>{record.project_type}</td>
                    <td>{numberFormat(record.project_price)}</td>
                    <td>{record.estimated_days}</td>
                    <td>{record.actual_days}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div className="report-heading m-t-1">
            <ReportFooter />
          </div>
        </div>
      </div>
    </Content>
  );
}
